<div style="margin: 20px; min-width: 1200px; min-height: 700px;">
  <p-panel header="Ruch na parkingu - filtr" [toggleable]="true" [style]="{'margin-bottom': '20px','background-color': 'transparent'}">
    <div class="ui-g">
      <div class="ui-g-12 ui-g-nopad ui-fluid">
        <div class="ui-g-4">
          <label>Od:</label>
          <p-calendar [(ngModel)]="filter.startDate" showTime="true" hourFormat="24" dateFormat="yy-mm-dd" [locale]="pl"></p-calendar>
        </div>
        <div class="ui-g-4">
          <label>Do:</label>
          <p-calendar [(ngModel)]="filter.endDate" showTime="true" hourFormat="24" dateFormat="yy-mm-dd" [locale]="pl"></p-calendar>
        </div>
        <div class="ui-g-4" valign="bottom">
          <div>Nr karty:</div>
          <input pInputText [(ngModel)]="filter.serialNumber"/>
        </div>
      </div>
      <div class="ui-g-12 ui-g-nopad ui-fluid">
        <div class="ui-g-4">
          <label>Nr biletu:</label>
          <input pInputText type="text" [(ngModel)]="filter.ticketNumber" />
        </div>
        <div class="ui-g-4">
          <label>Nr rejestracyjny:</label>
          <input pInputText type="text" [(ngModel)]="filter.licensePlate" />
        </div>
        <div class="ui-g-4">
          <label>Urządzenia:</label>
          <p-multiSelect [options]="devices" [(ngModel)]="selectedDevices" optionLabel="name" defaultLabel="Wybierz urządzenia"></p-multiSelect>
        </div>
      </div>
    </div>
    <p-footer>
      <div class="ui-g">
        <div class="ui-g-12" style="text-align: right;">
          <button pButton type="button" style="margin-left: 10px;" icon="pi pi-file-excel " label="Raport (xls)" (click)="downloadFile()"></button>
          <button pButton type="button" style="margin-left: 10px;" icon="pi pi-list" label="Szukaj" (click)="search()"></button>
        </div>
      </div>
    </p-footer>
  </p-panel>
  <p-table #dt [value]="recognitions" [paginator]="true" [rows]="limit">
    <ng-template pTemplate="header">
      <tr>
        <th width="60">Id</th>
        <th width="50">Urz&#261;dzenie</th>
        <th width="80">Czas rozpoznania</th>
        <th width="90">Numer rejestracyjny</th>
        <th width="100">Numer biletu</th>
        <th width="70">Numer karty</th>
        <th width="100">Przejazd</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-recognition>
      <tr>
        <td style="white-space: nowrap;">
          {{recognition.id}}
          <span [ngSwitch]="recognition.recognitionSource" style="float: right; ">
            <i *ngSwitchCase="'DIVA'" (click)="showImage($event,recognition,op1);" class="pi pi-camera" style="font-size: 2em; cursor: pointer; color: #aa4444;"></i>
            <i *ngSwitchCase="'HIKVISION'" (click)="showImage($event,recognition,op1);" class="pi pi-camera" style="font-size: 2em; cursor: pointer; color: #44aa44;"></i>
            <i *ngSwitchCase="'ECVISION'" (click)="showImage($event,recognition,op1);" class="pi pi-camera" style="font-size: 2em; cursor: pointer; color: #4444aa;"></i>
            <i *ngSwitchDefault (click)="showImage($event,recognition,op1);" class="pi pi-camera" style="font-size: 2em; cursor: pointer;"></i>
          </span>
        </td>
        <td align="left">{{devicesMap.get(recognition.line).name}}</td>
        <td>{{recognition.recognitionTime | date:"yyyy-MM-dd HH:mm:ss"}}</td>
        <td>{{recognition.licensePlate}}</td>
        <td>{{recognition.ticketNumber}}</td>
        <td style="white-space: normal; word-break: break-word;">{{recognition.serialNo}}</td>
        <td>
          <div [ngSwitch]="recognition.recognitionStatus">
            <span *ngSwitchCase="'UNKNOWN'"></span>
            <span *ngSwitchCase="'NO_TICKET'">Bez biletu</span>
            <span *ngSwitchCase="'NOT_REGISTERED'">Karta niezarejestrowana</span>
            <span *ngSwitchCase="'NOT_RECOGNIZED'">Karta</span>
            <span *ngSwitchCase="'NOT_RECOGNIZED_CARD'">Karta</span>
            <span *ngSwitchCase="'NOT_RECOGNIZED_QRCODE'">Kod QR</span>
            <span *ngSwitchCase="'NOT_RECOGNIZED_TAGM'">TagMaster</span>
            <span *ngSwitchCase="'RECOGNIZED'">Tablica rej.</span>
            <span *ngSwitchCase="'RESERVATION'">Rezerwacja</span>
            <span *ngSwitchCase="'NOT_CLEARED'">Bez przejazdu</span>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>

  <p-overlayPanel #op1 appendTo="body" >
    <img [src]="sanitizer.bypassSecurityTrustUrl(imageToShow)" width="600" *ngIf="imageToShow" />
    <img [src]="sanitizer.bypassSecurityTrustUrl(plateImageToShow)" width="150" *ngIf="plateImageToShow" style="float: right; margin-left: 10px;"/>
  </p-overlayPanel>
</div>
